<template>
	<!-- Celé je to nastavené tak, že se test zobrazí pouze pokud jsem v development prostředí, nebo na serveru, kde se testy vytváří a nebo musí být Published -->
	<div v-if="env.NODE_ENV === 'development' || env.VUE_APP_MODE === 'creation' || $store.state.testData.status === 'published'">
		
		<div class="d-flex justify-content-between flex-wrap mb-2">
			<div>
				<h3>
					Procvičte si tuto látku
				</h3>
			</div>
			<b-button @click="expand_collapseAll()" variant="white" class="ml-auto">
				<div class="d-flex align-items-center">
					<div class="text-uppercase mr-2 f-size-0-8">
						<template v-if="allIsExpanded">
							Zabalit vše
						</template>
						<template v-else>
							Rozbalit vše
						</template>
					</div>
					<div class="d-flex">
						<svg xmlns="http://www.w3.org/2000/svg" width="13.001" height="12.657" viewBox="0 0 13.001 12.657">
							<path d="M8307.988,4799.745h7.315l-3.658,3.657ZM8305,4797.5v-1h13v1Zm2.989-3.1,3.655-3.655,3.658,3.655Z" transform="translate(-8304.999 -4790.745)" fill="#333"/>
						</svg>
					</div>
				</div>
			</b-button>
		</div>

		<div role="tablist" class="test">

			<!-- TEST__INTRO -->
			<div v-if="$store.state.testData.description !== null"
				no-body class="test__intro" :class="{'test__intro--expanded' : introIsExpanded }" :style="'z-index:' + (questions.length)">

				<div class="test__intro__header"
					header-tag="header"
					role="tab"
					v-b-toggle="'accordion-intro'">
					<div class="d-flex justify-content-between align-items-center h-100">
						<div class="test__intro__heading">
							<h3>
								Úvod
							</h3>
						</div>
						<div class="px-3">
							<svg xmlns="http://www.w3.org/2000/svg" class="collapse-expand-icon" width="18px" viewBox="0 0 14 14">
								<circle class="cls-3" cx="7" cy="7" r="6.5"/>
								<line x2="6" transform="translate(3.999 7.001)"/>
								<line v-show="!introIsExpanded" transform="translate(6.999 4.001)" y1="6"/>
							</svg>
						</div>
					</div>
				</div>

				<b-collapse
					id="accordion-intro"
					v-model="introIsExpanded"
					role="tabpanel">

					<div class="p-3 p-md-4">
						<div class="test__intro__body">
							<v-runtime-template :template="findAndRenderLaTeX($store.state.testData.description)" />
						</div>
						
						<div class="d-flex justify-content-end">
							<b-button
								variant="dark-blue"
								v-b-toggle.accordion-intro
								@click="goToNextQuestion(0)">
								pokračovat
							</b-button>
						</div>
					</div>

				</b-collapse>

			</div>

			<!-- TEST__QUESTION -->
			<div
				no-body
				class="test__question"
				v-bind:key="question.id"
				v-for="(question, questionIndex) in questions"
				:id="'question' + questionIndex"
				:class="{
					'test__question--expanded' : question.expanded,
					'test__question--answered-correctly' : question.answerStatus === 'answeredCorrectly',
					'test__question--answered-incorrectly' : question.answerStatus === 'answeredIncorrectly',
					'test__question--answer-skipped' : question.answerStatus === 'answerSkipped',
				}"
				:style="'z-index:' + (questions.length - (questionIndex + 1))">

				<!-- TEST__QUESTION__HEADER -->
				<div
					class="test__question__header"
					header-tag="header"
					role="tab"
					v-b-toggle="'accordion-' + questionIndex">

					<div class="d-flex justify-content-between align-items-center h-100">

						<!-- TEST__QUESTION__HEADING -->
						<div class="test__question__heading">
							<h3>
								<span>
									{{ questionIndex + 1 }}. Otázka
								</span>
								<span class="points">
									| {{ question.points }} bodů
								</span>
							</h3>

							<!-- Ikony pro SPRÁVNOU odpověď / NESPRÁVNOU odpověď / PŘESKOČENOU otázku -->
							<svg v-if="question.answerStatus === 'answeredCorrectly'" class="correct-icon" width="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19.162">
								<path d="M24.548,54.323,22.355,52.13a1.558,1.558,0,0,0-2.193,0L9.581,62.726,4.839,57.968a1.493,1.493,0,0,0-1.1-.451,1.493,1.493,0,0,0-1.1.451L.452,60.162a1.558,1.558,0,0,0,0,2.194L6.29,68.194l2.194,2.194a1.558,1.558,0,0,0,2.194,0l2.194-2.194L24.548,56.517a1.558,1.558,0,0,0,0-2.194Z" transform="translate(0 -51.678)"/>
							</svg>
							<svg v-if="question.answerStatus === 'answeredIncorrectly'" class="incorrect-icon" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
								<path d="M8981.835,5919.737,8976,5913.9l-5.834,5.834a1.044,1.044,0,0,1-1.475,0l-2.386-2.383a1.045,1.045,0,0,1,0-1.475l5.835-5.835-5.835-5.834a1.045,1.045,0,0,1,0-1.475l2.386-2.385a1.04,1.04,0,0,1,1.473,0l5.835,5.835,5.836-5.835a1.043,1.043,0,0,1,1.475,0l2.384,2.383a1.044,1.044,0,0,1,0,1.477l-5.834,5.835,5.834,5.834a1.041,1.041,0,0,1,0,1.475l-2.384,2.383a1.04,1.04,0,0,1-1.475,0Z" transform="translate(-8966.001 -5900.044)"/>
							</svg>
							<svg  v-if="question.answerStatus === 'answerSkipped'" class="answer-skipped-icon" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 39.334 25.797">
								<g transform="translate(8841.854 5897.996)" fill="currentColor" stroke="currentColor">
									<circle cx="6" cy="6" r="6" transform="translate(-8832 -5887)" stroke="none"/>
									<path id="Path_16" data-name="Path 16" d="M-8818.854-5877.18c0-19.534,29.258-19.974,29.258,0" transform="translate(-21 -4)" fill="none" stroke-width="4"/>
									<path transform="translate(-8802.521 -5873.961) rotate(173)" d="M 7.231753349304199 1.02325439453125 C 7.570565700531006 1.02325439453125 7.909378528594971 1.191836357116699 8.101073265075684 1.52900218963623 L 13.61394309997559 11.22533226013184 C 13.99296379089355 11.89198207855225 13.51148319244385 12.71959209442139 12.74463367462158 12.71959209442139 L 1.718883514404297 12.71959209442139 C 0.9520235061645508 12.71959209442139 0.4705333709716797 11.89198207855225 0.8495635986328125 11.22533226013184 L 6.362433433532715 1.52900218963623 C 6.554128170013428 1.191836357116699 6.892940998077393 1.02325439453125 7.231753349304199 1.02325439453125 Z" stroke="none"/>
								</g>
							</svg>


						</div>

						<!-- Expand / Collapse ikona -->
						<div class="px-3">
							<svg xmlns="http://www.w3.org/2000/svg" class="collapse-expand-icon" width="18px" viewBox="0 0 14 14">
								<circle class="cls-3" cx="7" cy="7" r="6.5"/>
								<line x2="6" transform="translate(3.999 7.001)"/>
								<line v-show="!question.expanded" transform="translate(6.999 4.001)" y1="6"/>
							</svg>
						</div>
					</div>

				</div>
				
				
				<b-collapse
					:id="'accordion-' + questionIndex"
					v-model="question.expanded"
					role="tabpanel">
					
					<div class="p-3 p-md-4">
						<div class="position-relative">
							<div class="test__question__question">
								<v-runtime-template :template="findAndRenderLaTeX(question.question)" />
							</div>

							<!-- Dynamické načítání komponent na základě qestion.type -->
							<component :is="question.type" :questionIndex="questionIndex" ref="questions" />

							<!-- X pokusů / Neomezené množství pokusů -->
							<div v-if="
									question.type !== 'showAnswer'
									&& question.answerStatus === null
								"
								class="test__question__attempts-left">
								<span v-if="question.attempts_for_question === 0">
									<b>Neomezené množství pokusů</b>
								</span>
								<span v-else>
									{{
										inflection(
											(question.attempts_for_question - question.attemptsCount),
											['Zbývá', 'Zbývají', 'Zbývá'],
											false
										)
									}}
									<b>
										{{
											inflection(
												(question.attempts_for_question - question.attemptsCount),
												['pokus', 'pokusy', 'pokusů']
											)
										}}
									</b>
								</span>
							</div>

							<!-- Vysvětlení otázky -->
							<div
								v-if="question.answerStatus !== null && question.answerStatus !== 'answerSkipped' && question.explanation"
								class="test__question__explanation bg-warning px-3 py-3 rounded mt-2"
							>
								<v-runtime-template :template="findAndRenderLaTeX(question.explanation)" />
							</div>

							<div class="d-flex justify-content-between mt-3">

								<!-- Přeskočit -->
								<div style="z-index: 1" >
									<b-button
										v-if="question.answerStatus === null"
										@click="skipQuestion(questionIndex), questions[questionIndex + 1].expanded = true, questions[questionIndex].expanded = false"
										variant="white-gray">
										přeskočit
									</b-button>

									<b-button
										v-if="question.answerStatus === 'answerSkipped'"
										@click="unskipQuestion(questionIndex)"
										variant="white-gray">
										vrátit zpět
									</b-button>
								</div>

								<!-- Nápověda -->
								<div class="test__question__hint" :class="{'test__question__hint--displayed' : question.showHint}" v-if="question.hint">
									<div class="hint-container">

										<div v-show="question.showHint" class="hint-show-hide">
											<div class="hint-text">
												<v-runtime-template :template="findAndRenderLaTeX(question.hint)" />
											</div>
										</div>


										<div class="hint-button" @click="question.showHint = !question.showHint">
											<svg xmlns="http://www.w3.org/2000/svg" width="19.346" height="20.159" viewBox="0 0 19.346 20.159">
												<g transform="translate(-9.8)">
													<path id="XMLID_49_" d="M21.771,17.616v.589a.934.934,0,0,1-.792.925l-.145.535a.666.666,0,0,1-.643.494H18.751a.666.666,0,0,1-.643-.494l-.141-.535a.938.938,0,0,1-.8-.929v-.589a.566.566,0,0,1,.568-.568H21.2A.573.573,0,0,1,21.771,17.616Zm2.667-7.939a4.941,4.941,0,0,1-1.394,3.447A4.554,4.554,0,0,0,21.825,15.6a.821.821,0,0,1-.813.693H17.93a.813.813,0,0,1-.809-.689,4.6,4.6,0,0,0-1.228-2.48,4.966,4.966,0,1,1,8.545-3.443ZM20.033,6.67a.56.56,0,0,0-.56-.56,3.587,3.587,0,0,0-3.584,3.584.56.56,0,1,0,1.12,0A2.467,2.467,0,0,1,19.473,7.23.558.558,0,0,0,20.033,6.67Zm-.56-3.588a.56.56,0,0,0,.56-.56V.56a.56.56,0,0,0-1.12,0V2.522A.56.56,0,0,0,19.473,3.082ZM12.882,9.673a.56.56,0,0,0-.56-.56H10.36a.56.56,0,1,0,0,1.12h1.962A.558.558,0,0,0,12.882,9.673Zm15.7-.56H26.624a.56.56,0,1,0,0,1.12h1.962a.56.56,0,1,0,0-1.12ZM14.023,14.335l-1.39,1.39a.559.559,0,0,0,.788.792l1.39-1.39a.559.559,0,0,0-.788-.792ZM24.529,5.177a.559.559,0,0,0,.394-.162l1.39-1.39a.56.56,0,0,0-.792-.792l-1.39,1.39a.558.558,0,0,0,0,.792A.569.569,0,0,0,24.529,5.177ZM14.023,5.011a.559.559,0,1,0,.788-.792l-1.39-1.39a.56.56,0,0,0-.792.792Zm10.9,9.324a.56.56,0,0,0-.792.792l1.39,1.39a.559.559,0,0,0,.788-.792Z"/>
												</g>
											</svg>
										</div>

									</div>
								</div>

								<!-- Vyhodnotit / Pokračovat / Hotovo -->
								<div style="z-index: 1">
									
									<!-- Vyhodnocení otázky -->
									<b-button
										v-if="question.answerStatus === null && question.type !== 'showAnswer'"
										@click="$refs.questions[questionIndex].evaluateAnswer()"
										variant="green">
										vyhodnotit
									</b-button>

									<!-- Pokračovat na další otázku -->
									<b-button
										v-if="(question.answerStatus !== null || question.type === 'showAnswer') && (questionIndex + 1) !== $store.state.testData.questions.length"
										@click="goToNextQuestion(questionIndex + 1)"
										:disabled="question.answerStatus === null"
										variant="dark-blue">
										pokračovat
									</b-button>

									<!-- Vyhodnocení testu -->
									<b-button
										v-if="(questionIndex + 1) === $store.state.testData.questions.length && question.answerStatus !== null"
										@click="questions[questionIndex].expanded = false, showFinish = true"
										:disabled="!canFinishBeShown()"
										variant="dark-blue">
										hotovo
									</b-button>

								</div>
							</div>
						</div>
					</div>
				</b-collapse>
				
			</div>
		</div>

		<!-- TEST__FINISH -->
		<div v-if="showFinish" class="test__finish mt-3">
			<template v-if="this.successRate >= $store.state.testData.minimum_percents_to_pass_test">
				<div class="test__finish__status success">
					<svg width="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19.162">
						<path fill="currentColor" d="M24.548,54.323,22.355,52.13a1.558,1.558,0,0,0-2.193,0L9.581,62.726,4.839,57.968a1.493,1.493,0,0,0-1.1-.451,1.493,1.493,0,0,0-1.1.451L.452,60.162a1.558,1.558,0,0,0,0,2.194L6.29,68.194l2.194,2.194a1.558,1.558,0,0,0,2.194,0l2.194-2.194L24.548,56.517a1.558,1.558,0,0,0,0-2.194Z" transform="translate(0 -51.678)"/>
					</svg>
					<div class="ml-2">
						Splněno na {{ this.successRate }}%
					</div>
				</div>
			</template>
			<template v-else>
				<div class="test__finish__status failure">
					<svg width="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path fill="currentColor" d="M8981.835,5919.737,8976,5913.9l-5.834,5.834a1.044,1.044,0,0,1-1.475,0l-2.386-2.383a1.045,1.045,0,0,1,0-1.475l5.835-5.835-5.835-5.834a1.045,1.045,0,0,1,0-1.475l2.386-2.385a1.04,1.04,0,0,1,1.473,0l5.835,5.835,5.836-5.835a1.043,1.043,0,0,1,1.475,0l2.384,2.383a1.044,1.044,0,0,1,0,1.477l-5.834,5.835,5.834,5.834a1.041,1.041,0,0,1,0,1.475l-2.384,2.383a1.04,1.04,0,0,1-1.475,0Z" transform="translate(-8966.001 -5900.044)"/>
					</svg>
					<div class="ml-2">
						Nesplněno ({{ this.successRate }}%)
					</div>
				</div>
			</template>

			<p class="text-black-50">
				Pokud si chcete procvičování zopakovat, načtěte stránku znovu.
			</p>
		</div>

	</div>
</template>

<script>
import axios from 'axios';

import { mapActions } from "vuex";

import ShowAnswer from "./questions/ShowAnswer";
import InputQuestion from "./questions/InputQuestion";
import MultipleChoice from "./questions/MultipleChoice";
import SingleChoice from "./questions/SingleChoice";
import DragNDrop from "./questions/DragNDrop";

export default {
	props: [
		'id',
		'env',
		],

	data() {
		return {
			testData: '',

			questionsSortOrder: [], // Pořadí otázek, v jakém se budou po sobě vykreslovat

			questions: [],

			showFinish: false,

			introIsExpanded: true,

			allIsExpanded: false,
		};
	},

	components: {
		ShowAnswer,
		InputQuestion,
		MultipleChoice,
		SingleChoice,
		DragNDrop,
	},

	created() {
		// Načtení všech potřebných dat z API
		axios
			.get(
				'https://learntube.pl/_/items/test/' + (this.$props.id ? this.$props.id : this.$route.query.id)  + '?fields=*,questions.question_id.*'
			)
			.then(response => {
				let testData = response.data.data;

				//// DOLADĚNÍ ZÍSKANÝCH DAT
				
				// Definice potřebných proměnných
				testData.successPointsMaximum = 0; // Celkový (maximální) počet bodů, který se dá za test získat
				testData.successPoints = 0; // Do této proměnné se budou přičítat body za správně zodpovězenou otázku
				testData.answeredQuestionsCount = 0; // Počet zodpovězených otázek (bez ohledu na to, jestli dobře, nebo správně)

				// Úprava jednotlivých otázek před uložením
				testData.questions.forEach((question, index) => {

					testData.questions[index] = question.question_id; // Každá položka pole s otázkami je z API předaná pod objektem "question_id" -> zrušení tohoto objektu

					testData.questions[index].answerStatus = null; // Přidání proměnné "answered = null" ke každé otázce

					testData.questions[index].attemptsCount = 0; // Počet chybných pokusů u každé otázky

					testData.questions[index].showHint = false; // Počáteční stav pro Nápovědu

					testData.successPointsMaximum += testData.questions[index].points; // Spočítání celkového (maximálního) počtu bodů, který se dá za test získat

					// Pro všechny otázky, které nemají nastavený počet pokusů, se nastaví defaultní počet, definovaný pro celý test
					if (testData.questions[index].attempts_for_question === null) {
					testData.questions[index].attempts_for_question = testData.attempts_for_question;
					}
				});
				
				///// SEŘAZENÍ OTÁZEK
				if (testData.questions_order) { // Pokud je v testu definované přesné pořadí otázek (na základě jejich ID), tak podle toho otázky seřadím
					const questionsOrderArray = testData.questions_order.split(','); // převedení pořadí otázek na pole
					questionsOrderArray.forEach((questionId, index) => {
						let indexOfQuestionToSort = testData.questions.findIndex((question) => {
							return question.id == questionId;
						});
						if (indexOfQuestionToSort >= 0) { // jestli daný index vůbec existuje
							// Prohodím iterovanou otázku s tou, která má být na jejím místě
							let iteratedQuestion = testData.questions[index];
							testData.questions[index] = testData.questions[indexOfQuestionToSort];
							testData.questions[indexOfQuestionToSort] = iteratedQuestion;
						}
					});
				} else { // Pokud pořadí definované není - otázky seřadím náhodně
					testData.questions = this.shuffle(testData.questions);
				}

				this.addTestData(testData);
				this.questions = this.$store.state.testData.questions;
			})
			.catch(error => {
				this.test = error;
			});

	},

	mounted() {

	},

	computed: {
		// Úspěšnost celého testu [%]
		successRate() {
			let successRate = this.$store.state.testData.successPoints / this.$store.state.testData.successPointsMaximum;
			return Math.round( successRate * 100 );;
		},
		
	},

	methods: {
		...mapActions([
			'addTestData',
			'skipQuestion',
			'unskipQuestion',
		]),

		goToNextQuestion(nextQuestionIndex) {
			if (nextQuestionIndex === 0) {
				this.questions[nextQuestionIndex].expanded = true
			} else {
				const actualQuestionIndex = nextQuestionIndex - 1
				this.questions[actualQuestionIndex].expanded = false;
				this.questions[nextQuestionIndex].expanded = true;
			}
			// Na závěr se najede na danou otázku
			setTimeout(() => { // setTimeout je zde kvůli tomu, aby se počkalo až se vykoná animace rozbalování / zabalování accordeonů (jinak to nefunguje)
				this.$scrollTo('#question' + nextQuestionIndex, {
					offset: -50, // -50 proto, aby byla vidět i předchozí otázka
				});
			}, 400);
		},

		// Rozbalí nebo skryje všechny otázky, včetně úvodu
		expand_collapseAll() {
			this.introIsExpanded = this.allIsExpanded ? false : true;
			this.questions.forEach((question, index) => {
				this.questions[index].expanded = this.allIsExpanded ? false : true;
			});
			
			this.allIsExpanded = this.allIsExpanded ? false : true;
		},

		canFinishBeShown() {
			let boolToReturn = true;
			this.$store.state.testData.questions.forEach(question => {
				if (question.answerStatus === null) {
					boolToReturn = false;
				}
			});
			return boolToReturn;
		},
	}
};
</script>

